const DELAY_HANDLE_FREE_GIFT = 800;
const DELAY_RE_RENDER_AJAX_CART = 1000;

// Utils

const checkCart = async (cart) => {
  if (!Boolean(cart?.items) && !Boolean(cart?.total_price)) {
    const response = await fetch('/cart.js');
    cart = await response.json();
  }
  return cart;
};

const getTagWithfetchProduct = async (handle) => {
  const response = await fetch(`/products/${handle}.js`);
  const json = await response.json();
  return json.tags;
};

const getItemWithTags = async (items) => {
  const response = await Promise.all(
    items.map(async (item) => {
      const { handle, id, quantity } = item;
      let tags = sessionStorage.getItem(handle);

      if (typeof tags === 'string') {
        tags = tags.length ? tags.split(',') : [];
      } else {
        tags = await getTagWithfetchProduct(handle);
        sessionStorage.setItem(handle, tags.length ? tags.join(',') : '');
      }

      return {
        id,
        handle,
        tags,
        quantity,
      };
    }),
  );
  return response;
};

const formatStringToCompare = (text) => {
  return text
    .toLowerCase()
    .trim()
    .replaceAll(' ', '-');
};

const addRemoveFreeGiftV2 = async (keyId, quantity = 1, fetchType = 'add') => {
  await fetch(`/cart/${fetchType}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: keyId,
      quantity,
    }),
  });

  // window.dispatchEvent(new Event('custom::reRenderAjaxCart'));
};

const findGiftAdded = ({ keyConfig, items }) => {
  const config = window.FREE_GIFT_PURCHASE_CONFIG[keyConfig];
  if (!Boolean(config)) return undefined;

  const { gwpVariantID: CONFIG_VARIANT_ID } = config;

  const itemFreeGift = items.find((item) => item.variant_id === CONFIG_VARIANT_ID);

  return itemFreeGift;
};

const addRemovePreviousGift = async ({ tier, operation, items, totalItemsWithTag }) => {
  const keyConfig = `buyXgetGWP_${tier}`;
  const config = window.FREE_GIFT_PURCHASE_CONFIG[keyConfig];
  if (!Boolean(config)) return;

  const { gwpVariantID: CONFIG_VARIANT_ID, quantity: CONFIG_QUANTITY } = config;

  if (operation === 'remove') {
    await addRemoveFreeGiftV2(String(CONFIG_VARIANT_ID), 0, 'change');
  }

  if (operation === 'add') {
    if (totalItemsWithTag >= CONFIG_QUANTITY) {
      // add GWP 1
      await addRemoveFreeGiftV2(String(CONFIG_VARIANT_ID));
    }
    return;
  }
};

const loading = (val) => {
  const element = document.querySelector('[data-loading]');
  if (val) {
    if ([...element.classList].includes('hidden')) element.classList.remove('hidden');
  } else {
    element.classList.add('hidden');
  }
};

// End Utils

// Promo Types

const buyTotalgetGWP = async ({ items, totalPrice, keyConfig }) => {
  const { enable: CONFIG_ENABLE, threshold: CONFIG_THRESHOLD, gwpVariantID: CONFIG_VARIANT_ID } = window.FREE_GIFT_PURCHASE_CONFIG[keyConfig];

  if (!CONFIG_ENABLE) {
    return;
  }

  const itemFreeGift = findGiftAdded({ keyConfig, items });

  const condition = totalPrice / 100 >= CONFIG_THRESHOLD;

  await logicPromo1({ condition, itemFreeGift, CONFIG_VARIANT_ID });
};

const buyXgetGWP = async ({ items, keyConfig, promo, tier }) => {
  const { enable: CONFIG_ENABLE, quantity: CONFIG_QUANTITY, tag: CONFIG_TAG, gwpVariantID: CONFIG_VARIANT_ID } = window.FREE_GIFT_PURCHASE_CONFIG[keyConfig];

  if (!CONFIG_ENABLE) return;

  const itemFreeGift = findGiftAdded({ keyConfig, items });
  let itemsFilter = [...items];
  if (itemFreeGift) {
    // TODO: filter also products with GIF TAG
    itemsFilter = items.filter((item) => item.id !== itemFreeGift.id);
  }

  const itemsWithTags = await getItemWithTags(itemsFilter);
  let totalItemsWithTag = 0;
  itemsWithTags.forEach((item) => {
    const tagFound = item.tags.find((tag) => formatStringToCompare(tag) === formatStringToCompare(CONFIG_TAG));
    if (Boolean(tagFound)) {
      totalItemsWithTag += item.quantity;
    }
  });

  const condition = totalItemsWithTag >= CONFIG_QUANTITY;

  if (promo === 1) {
    await logicPromo1({ condition, itemFreeGift, CONFIG_VARIANT_ID });
  } else if (promo === 2) {
    await logicPromo2({ condition, itemFreeGift, keyConfig, tier, items, totalItemsWithTag, CONFIG_VARIANT_ID });
  }
  return;
};

const logicPromo1 = async ({ condition, itemFreeGift, CONFIG_VARIANT_ID }) => {
  if (condition) {
    if (!itemFreeGift) {
      await addRemoveFreeGiftV2(String(CONFIG_VARIANT_ID));
      return;
    }
    if (itemFreeGift.quantity > 1) {
      await addRemoveFreeGiftV2(itemFreeGift.key, 1, 'change');
      return;
    }
  } else {
    if (itemFreeGift) {
      await addRemoveFreeGiftV2(itemFreeGift.key, 0, 'change');
      return;
    }
  }
};

const logicPromo2 = async ({ condition, itemFreeGift, keyConfig, tier, items, totalItemsWithTag, CONFIG_VARIANT_ID }) => {
  if (condition) {
    const nextKeyConfig = keyConfig.replace(tier, tier + 1);
    const nextItemGift = findGiftAdded({ keyConfig: nextKeyConfig, items });
    if (!Boolean(itemFreeGift) && !Boolean(nextItemGift)) {
      // add the GWP
      await addRemoveFreeGiftV2(String(CONFIG_VARIANT_ID));

      if (tier === 2) {
        await addRemovePreviousGift({ tier: 1, operation: 'remove', items, totalItemsWithTag });
      }
      return;
    }
    if (itemFreeGift?.quantity > 1) {
      await addRemoveFreeGiftV2(itemFreeGift.key, 1, 'change');
      return;
    }
  } else {
    if (Boolean(itemFreeGift)) {
      // remover GWP
      await addRemoveFreeGiftV2(itemFreeGift.key, 0, 'change');

      if (tier === 2) {
        await addRemovePreviousGift({ tier: 1, operation: 'add', items, totalItemsWithTag });
      }
      return;
    }
  }
};

// End Promo Types

const openCartDrawer = () => {
  const cartButton = document.querySelector('[data-cart-drawer-button]');

  if (!!cartButton && theme.settings.enableAjax && cartButton.getAttribute('aria-expanded') == 'false') cartButton.click();
};

const handleFreeGift = async ({ detail = { cart: null } }) => {
  openCartDrawer();
  loading(true);

  const { items, total_price: totalPrice } = await checkCart(detail.cart);

  try {
    if (!items) {
      window.dispatchEvent(new Event('custom::reRenderAjaxCart'));
      return;
    }

    const { type: typePromo1 } = window.FREE_GIFT_PURCHASE_CONFIG.buyTotalOrXgetGWP;
    let removeGwpIds = window.localStorage.getItem('gwp-remove-ids');
    if (removeGwpIds) {
      removeGwpIds = removeGwpIds.split(',');
    } else {
      removeGwpIds = [];
    }

    if (typePromo1 === 'threshold') {
      const { gwpVariantID } = window.FREE_GIFT_PURCHASE_CONFIG.buyTotalOrXgetGWP;
      if (!removeGwpIds.includes(gwpVariantID.toString())) {
        await buyTotalgetGWP({ items, totalPrice, keyConfig: 'buyTotalOrXgetGWP' });
      }
    } else if (typePromo1 === 'buy_x_get_y') {
      const { gwpVariantID } = window.FREE_GIFT_PURCHASE_CONFIG.buyTotalOrXgetGWP;
      if (!removeGwpIds.includes(gwpVariantID.toString())) {
        await buyXgetGWP({ items, keyConfig: 'buyTotalOrXgetGWP', promo: 1 });
      }
    }

    if (!removeGwpIds.includes(window.FREE_GIFT_PURCHASE_CONFIG.buyXgetGWP_1.gwpVariantID.toString())) {
      await buyXgetGWP({ items, keyConfig: 'buyXgetGWP_1', promo: 2, tier: 1 });
    }

    if (!removeGwpIds.includes(window.FREE_GIFT_PURCHASE_CONFIG.buyXgetGWP_2.gwpVariantID.toString())) {
      await buyXgetGWP({ items, keyConfig: 'buyXgetGWP_2', promo: 2, tier: 2 });
    }

    setTimeout(() => {
      window.dispatchEvent(new Event('custom::reRenderAjaxCart'));
      loading(false);
      setTimeout(() => {
        initRemoveGWPItems();
      }, 1000);
    }, DELAY_RE_RENDER_AJAX_CART);
  } catch (err) {
    window.dispatchEvent(new Event('custom::reRenderAjaxCart'));
    console.warn('ERROR ON GIFT PRODUCT HANDLING!!!');
    console.error(err);
    loading(false);
  }
};

const debounceGWP = (cb, delay = 1000) => {
  let timeout;

  return (...arg) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cb(...arg);
    }, delay);
  };
};

window.addEventListener('custom::openCartDrawer', openCartDrawer);
window.addEventListener('custom::cartChanged', debounceGWP(handleFreeGift, DELAY_HANDLE_FREE_GIFT));

const initRemoveGWPItems = () => {
  const removeGwpItems = document.querySelectorAll('[data-remove-gwp]');
  if (removeGwpItems && removeGwpItems.length > 0) {
    removeGwpItems.forEach(item => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const gwpId = event.target.closest('button').dataset.removeGwp;
        openGwpRemoveModal(gwpId);
      });
    });
  }

  updateGwpItems();
  updateGwpMessage();
}

const updateGwpItems = () => {
  const gwpLineItems = document.querySelectorAll('[data-gwp-lineitem]');
  let removeGwpIds = window.localStorage.getItem('gwp-remove-ids');
  if (!removeGwpIds) {
    removeGwpIds = [];
  }
  
  gwpLineItems.forEach(item => {
    const gwpId = item.getAttribute('data-gwp-lineitem');
    if (removeGwpIds.includes(gwpId)) {
      item.classList.add('hidden');
    } else {
      item.classList.remove('hidden');
    }
  });
}

const openGwpRemoveModal = (gwpId) => {
  // Check empty modal
  const emptyModal = document.querySelector('#EmptyTarget2 [data-gwp-remove-modal]');
  if (emptyModal) {
    emptyModal.parentElement.removeChild(emptyModal);
  }
  const modal = document.querySelector('[data-gwp-remove-modal]');
  if (modal) {
    modal.classList.remove('hidden');
    modal.setAttribute('data-gwp-remove-id', gwpId);
  };
};

const hideGwpRemoveModal = () => {
  const modal = document.querySelector('[data-gwp-remove-modal]');
  if (modal) {
    modal.classList.add('hidden');
  }
};

let checkGwpInterval = 0;
const gwpInterval = setInterval(() => {
  const cartItems = document.querySelectorAll('[id^="CartItem-"]');
  if (cartItems.length > 0) {
    clearInterval(gwpInterval);
    initRemoveGWPItems();
  }
  if (++checkGwpInterval == 200) {
    clearInterval(gwpInterval);
  }
}, 100);

const initGwpModal = () => {
  const btnNo = document.querySelector('[data-close-gwp-remove-modal]');
  if (btnNo) {
    btnNo.addEventListener('click', () => {
      hideGwpRemoveModal();
    });
  }

  const btnYes = document.querySelector('[data-confirm-gwp-remove-modal]');
  if (btnYes) {
    btnYes.addEventListener('click', () => {
      let gwpRemoveIds= window.localStorage.getItem('gwp-remove-ids');
      if (!gwpRemoveIds) {
        gwpRemoveIds = [];
      } else {
        gwpRemoveIds = gwpRemoveIds.split(',');
      }

      const gwpId = document.querySelector('[data-gwp-remove-modal]').getAttribute('data-gwp-remove-id');
      if (!gwpRemoveIds.includes(gwpId)) {
        gwpRemoveIds.push(gwpId);
      }

      window.localStorage.setItem('gwp-remove-ids', gwpRemoveIds.toString());

      removeGwpFromCart();
      hideGwpRemoveModal();
      updateGwpItems();
      updateGwpMessage();
      window.updateCartCount();

      loading(true);
      setTimeout(() => {
        window.dispatchEvent(new Event('custom::reRenderAjaxCart'));
        loading(false);
      }, DELAY_RE_RENDER_AJAX_CART);
    });
  }

  const modal = document.querySelector('[data-gwp-remove-modal]');
  if (modal) {
    modal.addEventListener('click', () => {
      hideGwpRemoveModal();
    })
  }
};

const updateGwpMessage = () => {
  const gwpLineItems = document.querySelectorAll('[data-gwp-lineitem]');
  if (gwpLineItems.length > 0) {
    const gwpMessage = document.querySelector('[data-gwp-messages]');
    if (Array.from(gwpLineItems).findIndex(item => !item.classList.contains('hidden')) == -1) {
      gwpMessage.classList.add('hidden');
    } else {
      gwpMessage.classList.remove('hidden');
    }
  }
};

initGwpModal();

// Checkout handle
const removeGwpFromCart = () => {
  let removeGwpIds = localStorage.getItem('gwp-remove-ids');
  if (removeGwpIds) {
    removeGwpIds = removeGwpIds.split(',');
    let options = {};
    removeGwpIds.forEach(id => {
      options[id] = 0;
    });

    jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
      updates: options
    });
  }
}
